import NewSurveyTemplate from './templates/New/NewTemplateContainer';
import SurveyTemplateDetail from './templates/Details/DetailContainer';
import SurveyRespondentDetail from './detail/SurveyRespondentDetail';
import SurveyListContainer from './SurveyListContainer';
import SurveyTempListContainer from './templates/SurveyTempListContainer';
import NewSurveyContainer from './new/NewSurveyContainer';
import SurveyDetailContainer from './detail/SurveyDetailContainer';

const surveyRoutes = [
  { path: '/accounts/:aid/surveys/', component: SurveyListContainer, exact: true },
  { path: '/accounts/:aid/surveys/new/:respondentId', component: NewSurveyContainer },
  { path: '/accounts/:aid/surveys/templates', component: SurveyTempListContainer, exact: true },
  { path: '/accounts/:aid/surveys/templates/new', component: NewSurveyTemplate },
  { path: '/accounts/:aid/surveys/templates/:templateId', component: SurveyTemplateDetail },
  { path: '/accounts/:aid/surveys/:surveyId/respondents/:surveyRespondentId', component: SurveyRespondentDetail },
  { path: '/accounts/:aid/surveys/:surveyId', component: SurveyDetailContainer },
];

export default surveyRoutes;
